import { Duration, isDuration } from 'moment';

export default function durationToMilliseconds(duration: number | Duration) {
  if (isDuration(duration)) {
    return duration.asMilliseconds();
  }
  return duration;
}
